import { render, staticRenderFns } from "./CustomerContactReport.vue?vue&type=template&id=1480582f&scoped=true"
import script from "./CustomerContactReport.vue?vue&type=script&lang=js"
export * from "./CustomerContactReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerContactReport.vue?vue&type=style&index=0&id=1480582f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480582f",
  null
  
)

export default component.exports